import {useCallback} from 'react';
import {TWhatsAppProps, TEmailProps, TSmsProps} from '../types';
import {TXHR} from '../../../assets/constants/constansts.type';

interface CreateSendingPropsParams {
    whatsappData: {image: {path: string, imageId: string}, message: string};
    emailData: {image: {path: string, imageId: string}, emailBody: string, emailSubject: string};
    smsData: {message: string};
    handleDataSave: (data: any, key: string, type: string) => void;
    handleSend: (type: string, trialRecipients?: string[]) => Promise<boolean>;
    sendingXHR: TXHR;
    whatsappTemplate: {prefix: string, suffix: string, buttons: string[], maxLines: number};
    variablesType: string;
}

export const createSendingProps = ({
    whatsappData,
    emailData,
    smsData,
    handleDataSave,
    handleSend,
    sendingXHR,
    whatsappTemplate,
    variablesType
}: CreateSendingPropsParams) => {
    const createProps = useCallback((type: 'whatsapp' | 'email' | 'sms') => {
        const baseProps = {
            send: () => handleSend(type),
            sendTrial: (trialPhones: string[]) => handleSend(type, trialPhones),
            sendingXHR
        };

        switch (type) {
            case 'whatsapp':
                return {
                    ...baseProps,
                    image: whatsappData.image,
                    text: whatsappData.message,
                    saveImage: (image: string) => handleDataSave({path: image, imageId: ''}, 'image', type),
                    saveText: (text: string) => handleDataSave(text, 'message', type),
                    whatsappTemplate: variablesType,
                    whatsappPrefix: whatsappTemplate?.prefix,
                    whatsappSuffix: whatsappTemplate?.suffix,
                    whatsappButtons: whatsappTemplate?.buttons,
                    maxLines: whatsappTemplate?.maxLines
                } as TWhatsAppProps;

            case 'email':
                return {
                    ...baseProps,
                    image: emailData.image,
                    emailBody: emailData.emailBody,
                    emailSubject: emailData.emailSubject,
                    setEmailBody: (text: string) => handleDataSave(text, 'emailBody', type),
                    setEmailSubject: (subject: string) => handleDataSave(subject, 'emailSubject', type),
                    saveImage: (image: string) => handleDataSave({path: image, imageId: ''}, 'image', type)
                } as TEmailProps;

            case 'sms':
                return {
                    ...baseProps,
                    message: smsData.message,
                    saveMessage: (message: string) => handleDataSave(message, 'message', type),
                    variablesType: variablesType
                } as TSmsProps;

            default:
                return baseProps;
        }
    }, [whatsappData, emailData, smsData, handleDataSave, handleSend, sendingXHR, variablesType]);

    return {
        whatsappProps: createProps('whatsapp') as TWhatsAppProps,
        emailProps: createProps('email') as TEmailProps,
        smsProps: createProps('sms') as TSmsProps
    };
};
